import { Grid, Paper, styled, Typography } from '@mui/material'

export const LoaderContainer = styled(Paper)({
  padding: '2rem 2rem 0',
  height: 520,
  textAlign: 'center',
  '& >span': {
    marginBottom: '1rem',
    '&:first-of-type': {
      margin: '0 5px 1rem',
    },
  },
})

export const CardContainer = styled(Grid)(({ theme }) => ({
  margin: 'auto',
  paddingRight: '1rem',
  maxWidth: 1900,
  [theme.breakpoints.down(1780)]: {
    maxWidth: theme.breakpoints.values.lg,
  },
  [theme.breakpoints.down('lg')]: {
    maxWidth: 950,
  },
  [theme.breakpoints.down(925)]: {
    maxWidth: 650,
  },
  [theme.breakpoints.down(650)]: {
    maxWidth: 500,
  },
  '& a': {
    textDecoration: 'none',
  },
  '& nav': {
    margin: '1rem 0 3rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}))

export const ContainerTitle = styled(Typography)({
  margin: '4rem 0 2rem',
})
